<template>
  <!--
      	作者：rj.wu
      	时间：2021-04-15
      	描述：插件中心-第三方支付
      -->
  <div class="product-add">
    <el-form size="small" ref="form" :model="form">
      <el-form-item label="是否开启第三方支付" prop="is_open">
        <el-switch v-model="form.is_open"></el-switch>
        <div class="gray9">开启后，用户支付的金额直接去到第三方商户平台</div>
      </el-form-item>
      <el-form-item label="是否开启第三方银行卡代付打款" prop="is_pay_agent">
        <el-switch v-model="form.is_pay_agent"></el-switch>
        <div class="gray9">开启后，用户提现到银行卡可直接走第三方代付打款通道</div>
      </el-form-item>

      <el-form-item label="默认第三方支付" prop="default">
        <el-select v-model="form.default" clearable>
          <el-option v-for="(item, index) in form.company" :value="index" :key="index" :label="item.name+(form.default == index ? '（默认）' : '')"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="新增公司KEY值" prop="default">
        <el-input size="small" type="text" v-model="newCompany" style="width:200px">
          <el-button slot="append" type="primary" icon="el-icon-plus" size="small" @click="addTab">添加</el-button>
        </el-input>
      </el-form-item>

      <el-tabs v-model="activeName" @tab-click="handleClick" closable @tab-remove="removeTab">
        <el-tab-pane :label="item.name+(form.default == index ? '（默认）' : '')" :name="index" v-for="(item, index) in form.company" :key="index">
            <div v-if="activeName==index">
              <div class="common-form"><span class="mr10">{{ item.name+' '+activeName }}</span> <el-button size="small" class="el-icon-plus" @click="addRow(index)">添加</el-button></div>
              <div class="mb10" v-for="(v, i) in list" :key="i">
                <el-input size="small" type="text" v-model="v.key" style="width:300px"></el-input>
                <el-input size="small" type="text" v-model="v.value" style="width:300px"></el-input>
                <el-button type="info" size="mini" plain icon="el-icon-close" @click="delRow(i)"></el-button>
              </div> 
            </div>
            
        </el-tab-pane>
      </el-tabs>
      
      <!--提交-->
      <div class="common-button-wrapper"><el-button type="primary" size="small" @click="onSubmit" :loading="loading">提交</el-button></div>
    </el-form>
  </div>
</template>

<script>
import PaymentApi from '@/api/payment.js';
export default {
  data() {
    return {
      form: {
        is_open: 0,
        is_pay_agent: 0,
        company: [],
      },
      list: [],
      loading: false,
      activeName: '',
      newCompany: '',
    };
  },
  created() {
    /*获取数据*/
    this.getData();
  },
  methods: {
    /*切换*/
    handleClick(tab, event) {
      let item = this.form.company[this.activeName];
      this.changeData(item);
    },
    /*获取数据*/
    getData() {
      let self = this;
      let Params = {};
      PaymentApi.getData(Params, true)
        .then(data => {
          self.loading = false;
          self.form = data.data.vars.values;
          self.activeName = self.form.default;

          self.handleClick();
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*保存数据*/
    onSubmit() {
      let self = this;
      let params = self.form;

      // 数组转obj
      let items = {};
      self.list.forEach(v => {
        items[v.key] = v.value
      });
      params.company[self.activeName] = items;

      self.loading = true;
      PaymentApi.saveData(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getData();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
    
    /*添加支付方式*/
    addTab() {
      if (!this.newCompany){
        this.$message({
          message: '填写新增公司KEY值',
          type: 'warning'
        });
        return;
      }
      let data = {'name': '新增'+this.newCompany};
      this.form.company[this.newCompany] = data;
      console.log(this.form.company);
      this.$forceUpdate();
    },

    /*删除支付方式*/
    removeTab(targetName) {
      if(this.form.default == targetName){
        this.$message({
          message: '默认方式不能删除',
          type: 'warning'
        });
        return;
      }
      this.$confirm('确定是否删除该支付方式?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        let count = this.length(this.form.company);
        if (count <= 1){
          this.$message({
            message: '最少保留1种方式',
            type: 'warning'
          });
          return;
        }
        delete this.form.company[targetName];
        this.$forceUpdate();
        for(let i in this.form.company){
          this.activeName = i;
          break;
        }
      }).catch(() => {});
    },

    /*添加行*/
    addRow(){
      let data = {'key': '','value':''};
      this.list.push(data);
    },

    /*删除行*/
    delRow(i){
      this.$confirm('确定是否删除该行?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        this.list.splice(i, 1);
      }).catch(() => {});
    },

    /*obj转数组*/
    changeData(data){
      this.list = [];
      for(let i in data){
        this.list.push({key:i, value:data[i]})
      }
    },

    length(obj) {
      var count = 0;
      for(var i in obj){
          count ++;
      }
      return count;
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/payment/index.vue